import { useTranslation } from '@/i18n/useTranslation';

import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { ScanTrendPoint } from '@/api/endpoints/scanAnalytics';

export function ScanTrendChart({ data }: { data: ScanTrendPoint[] }) {
  const { locale, t } = useTranslation();
  const chartData = data.map((point) => ({
    ...point,
    label: new Date(point.bucket).toLocaleDateString(locale),
  }));
  return (
    <div role="img" aria-label={t('Saved inspections and inspections with detections over time')}>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#dbe3e1" />
          <XAxis dataKey="label" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="total_inspections"
            name={t('Saved inspections')}
            stroke="#327d75"
            strokeWidth={2.5}
          />
          <Line
            type="monotone"
            dataKey="with_detections"
            name={t('With detections')}
            stroke="#f85f2a"
            strokeWidth={2.5}
          />
        </LineChart>
      </ResponsiveContainer>
      <table className="visually-hidden">
        <caption>{t('Daily saved inspections')}</caption>
        <thead>
          <tr>
            <th>{t('Day')}</th>
            <th>{t('Inspections')}</th>
            <th>{t('With detections')}</th>
          </tr>
        </thead>
        <tbody>
          {chartData.map((point) => (
            <tr key={point.bucket}>
              <td>{point.label}</td>
              <td>{point.total_inspections}</td>
              <td>{point.with_detections}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
